import { FC } from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
const { Option } = Select

interface Props {
  onChangeDuration: (type: number) => void
  duration: number
}

const durationTimes = [1800, 3600, 5400, 7200, 9000, 10800]

export const MeetingInviteDurationSelect: FC<Props> = ({ onChangeDuration, duration }) => {
  const [t] = useTranslation()
  return (
    <Select
      onChange={(value: number) => onChangeDuration(value)}
      value={duration}
      defaultValue={3600}
      style={{ width: '128px' }}
      data-e2e-duration-select
    >
      {durationTimes.map((duration) => {
        return (
          <Option key={duration} value={duration} data-e2e-duration={duration}>
            {duration / 3600} {duration === 1800 || duration === 3600 ? t('meetingInvite.hour') : t('meetingInvite.hours')}
          </Option>
        )
      })}
    </Select>
  )
}
